/**
 * shared/scoring/cp-weights.ts — W66.K Canonical CP Weight Module.
 *
 * SINGLE SOURCE OF TRUTH for M-PACT Checkpoint weights.
 * Locked by Bryan K. Short. All consumers must import from this module.
 * No other file may define CP weight values.
 *
 * CP1  Project                                    5%
 * CP2  Need / Pain / Demonstration               20%
 * CP3  Budget                                    10%
 * CP4  Timeline                                  10%
 * CP5  Authority — Project / Initiative          15%
 * CP6  Technical and Financial Sign-off          15%
 * CP7  Org Structure and Influence Map           15%
 * CP8  Competitive Position                       5%
 * CP9  Compliance — IT Internal and Industry-Specific  3%
 * CP10 Legal — Contracts, SLAs, Terms             2%
 *                                              ——————
 *                                      Sum =   100%
 *
 * DO NOT CHANGE THESE VALUES without explicit Bryan K. Short authorization.
 */

/**
 * Locked CP weights as a Record keyed by checkpoint number (1–10).
 * Values are integer percentages summing to 100.
 */
export const CP_WEIGHTS: Record<number, number> = {
  1: 5, 2: 20, 3: 10, 4: 10, 5: 15,
  6: 15, 7: 15, 8: 5,  9: 3,  10: 2,
};

/** Sum of all CP weights — must equal 100. */
export const CP_WEIGHTS_SUM = 100;

/** Number of checkpoints. */
export const CP_COUNT = 10;
